import React, { useEffect, useState } from "react";
import Underline from "../../../../components/page/home/underline/underline";
import ProgressBar from "../../../../components/progressbar/progressbar";
import { public_accomplishments_list } from "../../public.api";

export default function Accomplishments(props) {
  const [data, setdata] = useState({});

  const handleEventList = () => {
    public_accomplishments_list().then((res) => {
      setdata(res ?? {});
    });
  };
  useEffect(() => {
    handleEventList();
  }, []);
  return (
    <div>
      <div className="new-accomp-cont">
        <div className="new-accom-title">
          <div>
            {props.state.language === "ma"
              ? "ഞങ്ങളുടെ നേട്ടങ്ങൾ"
              : "Our Accomplishments"}
          </div>
        </div>

        <div className="acom-data">
          <div className="accom-rt">
            <div className="accom-title">
              <div className="accom-name-span">
                {props.state.language === "ma"
                  ? "കെസ്പെസിനുള്ളിലെ  കമ്പനികൾ"
                  : " Companies operating within KSPACE"}
              </div>
            </div>
            <div>
              <div className="accom-items-cont">
                <div className="progressCont">
                  <ProgressBar
                    progress={data?.kspace_company_count ?? 0}
                    iconName="company"
                    label={
                      props.state.language === "ma"
                        ? "കമ്പനികളുടെ എണ്ണം"
                        : "Number of Companies"
                    }
                  />
                </div>
                <div className="progressCont">
                  <ProgressBar
                    progress={data?.total_ex_man_power_kspace ?? 0}
                    iconName="employee"
                    label={
                      props.state.language === "ma"
                        ? "ജീവനക്കാരുടെ എണ്ണം"
                        : "Number of Employees"
                    }
                  />
                </div>

                <div className="progressCont">
                  <ProgressBar
                    progress={data?.total_capital_investment_kspace ?? 0}
                    iconName="invest"
                    label={
                      props.state.language === "ma"
                        ? "മൂലധന നിക്ഷേപം"
                        : "Capital Investment"
                    }
                    sub_label={
                      props.state.language === "ma" ? "(കോടിയിൽ)" : "(in Crore)"
                    }
                  />
                </div>
                <div className="progressCont">
                  <ProgressBar
                    progress={data?.total_fy_turnover ?? 0}
                    iconName="employee"
                    label={
                      props.state.language === "ma"
                        ? "വാര്ഷിക ടേൺ ഓവർ"
                        : "Annual Turnover"
                    }
                    sub_label={
                      props.state.language === "ma" ? "(കോടിയിൽ)" : "(in Crore)"
                    }
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="accom-left">
            <div className="accom-title">
              <div className="accom-name-span">
                {props.state.language === "ma"
                  ? "KSPACE-ൽ അഫിലിയേറ്റ് ചെയ്തിട്ടുള്ള കമ്പനികൾ"
                  : "Companies affiliated with KSPACE"}
              </div>
            </div>
            <div className="">
              <div className="accom-items-cont">
                <div className="progressCont">
                  <ProgressBar
                    progress={data?.kerala_company_count ?? 0}
                    iconName="company"
                    label={
                      props.state.language === "ma"
                        ? "കമ്പനികളുടെ എണ്ണം"
                        : "Number of Companies"
                    }
                  />
                </div>
                <div className="progressCont">
                  <ProgressBar
                    progress={data?.total_ex_man_power_kerala ?? 0}
                    iconName="employee"
                    label={
                      props.state.language === "ma"
                        ? "ജീവനക്കാരുടെ എണ്ണം"
                        : "Number of Employees"
                    }
                  />
                </div>

                <div className="progressCont">
                  <ProgressBar
                    progress={data?.total_capital_investment_kerala ?? 0}
                    iconName="invest"
                    label={
                      props.state.language === "ma"
                        ? "മൂലധന നിക്ഷേപം"
                        : "Capital Investment"
                    }
                    sub_label={
                      props.state.language === "ma" ? "(കോടിയിൽ)" : "(in Crore)"
                    }
                  />
                </div>
                <div className="progressCont">
                  <ProgressBar
                    progress={data?.total_turnover_kerala ?? 0}
                    iconName="turnover"
                    label={
                      props.state.language === "ma"
                        ? "വാർഷിക ടേൺ ഓവർ"
                        : "Annual Turn Over"
                    }
                    sub_label={
                      props.state.language === "ma" ? "(കോടിയിൽ)" : "(in Crore)"
                    }
                  />
                </div>
              </div>
            </div>{" "}
          </div>
          <div className="accom-left">
            <div className="accom-title">
              <div className="accom-name-span">
                {props.state.language === "ma"
                  ? "KSPACE-ൽ അഫിലിയേറ്റ് ചെയ്തിട്ടുള്ള കമ്പനികൾ"
                  : "Ongoing Projects"}
              </div>
            </div>
            <div className="">
              <div className="accom-items-cont">
                <div className="progressCont">
                  <ProgressBar
                    progress={data?.ongoing_company_count ?? 0}
                    iconName="company"
                    label={
                      props.state.language === "ma"
                        ? "കമ്പനികളുടെ എണ്ണം"
                        : "Number of Companies"
                    }
                  />
                </div>
                <div className="progressCont">
                  <ProgressBar
                    progress={data?.ongoing_expected_employment ?? 0}
                    iconName="employee"
                    label={
                      props.state.language === "ma"
                        ? "ജീവനക്കാരുടെ എണ്ണം"
                        : "No of Expected Employment"
                    }
                  />
                </div>

                <div className="progressCont">
                  <ProgressBar
                    progress={data?.ongoing_expected_capital_investment ?? 0}
                    iconName="invest"
                    label={
                      props.state.language === "ma"
                        ? "മൂലധന നിക്ഷേപം"
                        : "Expected Capital Investment"
                    }
                    sub_label={
                      props.state.language === "ma" ? "(കോടിയിൽ)" : "(in Crore)"
                    }
                  />
                </div>
              </div>
            </div>{" "}
          </div>
        </div>
      </div>
    </div>
  );
}
